import React from 'react';
import UserEventMessage from "./UserEventMessage";
import uiStore from "../../lib/stores/uiStore";
import {Message} from "../../lib/stores/MessageStore";

interface MessageProps {
    message: Message
    forwardedRef?: React.RefObject<HTMLDivElement>;
}

const JoinMessage: React.FC<MessageProps> = ({message, forwardedRef}) => {
    const isLandScapeMobile = uiStore.isLandScape() && uiStore.isMobile;

    return <UserEventMessage
            forwardedRef={forwardedRef}
            message={message}
            text={isLandScapeMobile ? ' joined' : ' has joined the room'}
    />
}

export default JoinMessage;
